import React, { useState, useEffect } from 'react';
import {
  DeleteButton,
  GalleryContainer,
  MainImage,
  MainImageContainer,
  ThumbnailButton,
  ThumbnailImage,
  ThumbnailsGrid
} from './styled';
import { useAttachments } from 'hooks/useAttachments';

export const ProductGallery = ({
  images,
  onDelete,
  readOnly = false,
  productId,
  productService
}) => {
  const { getFileURL } = useAttachments(productService, productId);
  const [selectedImage, setSelectedImage] = useState(0);

  useEffect(() => {
    if (selectedImage >= images.length && images.length > 0) {
      setSelectedImage(images.length - 1);
    } else if (images.length === 0) {
      setSelectedImage(0);
    }
  }, [images, selectedImage]);

  if (!images?.length) return null;

  return (
    <GalleryContainer>
      <ThumbnailsGrid>
        {images.map((image, index) => (
          <ThumbnailButton
            key={image.id}
            onMouseEnter={() => setSelectedImage(index)}
            selected={selectedImage === index}
          >
            <ThumbnailImage
              src={getFileURL(image.path)}
              alt={`Product thumbnail ${index + 1}`}
            />
            {!readOnly && onDelete && (
              <DeleteButton
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(image.id);
                }}
                title="Remover imagem"
              >
                ×
              </DeleteButton>
            )}
          </ThumbnailButton>
        ))}
      </ThumbnailsGrid>
      <MainImageContainer>
        <MainImage
          src={getFileURL(images[selectedImage].path)}
          alt={`Product ${selectedImage + 1}`}
        />
      </MainImageContainer>
    </GalleryContainer>
  );
};
